<template>
  <div class="user-questions">
    <div class="item" v-for="(item, index) in feedbackMessageList" :key="index">
      <div class="left">
        <div class="title ellipsis">{{ item.feedbackQuestion }}</div>
        <div class="answer ellipsis" v-if="item.finalReplyMessage">
          {{ item.finalReplyMessage }}
        </div>
        <div class="answer-other">
          <div>提问时间：{{ item.crDt }}</div>
          <div>承诺回复截止时间：{{ item.finalPromiseDate }}</div>
          <div v-if="item.finalReplyDate">
            回复时间：{{ item.finalReplyDate }}
          </div>
          <div v-if="item.closeType">
            患者是否通过：{{ item.closeType == 1 ? "通过" : "不通过" }}
          </div>
        </div>
        <div class="start text-red" v-if="item.closeType == 0">解答中</div>
        <div class="start text-green" v-else>已关闭</div>
      </div>
      <div class="right">
        <Button size="small" @click="onDetail(item)">详情</Button>
      </div>
    </div>
    <empty v-if="!feedbackMessageList.length" text="暂无数据" />
    <userQuestionsDetail ref="userQuestionsDetailRef" @close="getData" />
  </div>
</template>

<script>
import userQuestionsDetail from "./userQuestionsDetail.vue";
export default {
  components: {
    userQuestionsDetail,
  },
  props: {
    patientCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeItem: {},
      feedbackMessageList: [],
    };
  },
  methods: {
    onDetail(item) {
      this.$refs.userQuestionsDetailRef.open(item);
    },
    getData() {
      this.api2("getFeedbackMessageList", {
        patientCode: this.patientCode,
      }).then((res) => {
        this.feedbackMessageList = res.result;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>


<style scoped lang="scss">
.user-questions {
  padding: 15px;
  .item {
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid #eee;

    .left {
      width: 100%;
      overflow: hidden;
      .title {
        font-weight: bold;
        margin-bottom: 5px;
      }
      .answer {
        margin-bottom: 5px;
      }
      .answer-other {
        opacity: 0.6;
        margin-bottom: 5px;
      }
    }
    .right {
      width: 150px;
      flex-shrink: 0;
      text-align: right;
    }
  }
}
</style>